export class editPreguntas {
    dataService
    preguntas
    dataview
    index
    service
    constructor(data,index) {
        
        this.service = data;
        this.preguntas = data.listRatinggs[index].rattings;
        this.dataService = data;
         this.index = index;
    }

    reset(){
       return this.service.listRatinggs[this.index].rattings;
    }
}